<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="panel">
        <div class="panel-hdr">
          <div class="w-100">
            <div class="row">
              <div class="col-lg-6 col-sm-12">
                <h1 class="subheader-title mb-2 mb-lg-0">
                  <i class="subheader-icon fal fa-clipboard-list"></i> Проверка серверов
                </h1>
              </div>
              <div class="col-lg-6 col-sm-12 text-lg-right text-sm-left" v-if="tasks.length > 0 || search">
                <button data-button="task-create" class="btn btn-sm btn-outline-success mr-2" v-on:click="taskCreate">Добавить сервер</button>
                <div class="input-group input-group-sm d-inline-flex" v-bind:class="{ 'has-length': searchFocus }">
                  <div class="input-group-prepend">
                    <span class="input-group-text bg-transparent border-right-0">
                      <i class="fal fa-search"></i>
                    </span>
                  </div>
                  <input type="search" class="form-control border-left-0 bg-transparent pl-0" v-on:focus="searchFocus = true" v-on:blur="searchFocus = false" v-model="search" placeholder="Поиск"/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-container show">
          <TasksGroups v-bind:groupActive="group" type="ping" v-on:groupSelect="group = $event; taskListUpdate()"/>
          <div class="panel-content" v-if="tasks.length === 0 && !loading">
            <div class="text-center m-auto" style="max-width: 25em">
              <i class="fal fa-comment fa-3x color-primary-300"></i><br>
              <br />
              <button data-button="task-create" class="btn btn-outline-success mt-3" v-on:click="taskCreate">Добавить сервер</button>
              <div class="lead pt-3">Проверка доступности серверов не выполняется. Добавьте сервер, чтобы следить за его работоспособностью.</div>
            </div>
          </div>
          <div class="panel-container show" v-if="loading">
            <div class="panel-content p-6 m-6">
              <content-placeholders :centered="true">
                <content-placeholders-text :lines="4" />
              </content-placeholders>
            </div>
          </div>
          <div class="panel-content p-3" v-if="tasks.length > 0 && !loading">
            <div data-element="tasks" id="js_default_list">
              <paginate name="tasks" class="list-group" :list="tasks" :per="25">
                <li :data-id="task.id" class="list-group-item" v-for="(task, index) in paginated('tasks')" :key="task.id">
                  <span class="d-flex row align-items-center position-relative">
                    <div class="col-sm-8 col-8 col-lg-9">
                        <div class="row task">
                            <div :data-name="task.name" class="col-lg-3 col-6 col-sm-6 mb-2 mb-lg-0 text-center text-lg-left">
                                <span class="fs-xl text-truncate text-truncate-lg text-dark fw-500">
                                    {{ task.name }}
                                    <span class="d-block fs-sm fw-400 text-muted">
                                        {{ task.value }}
                                    </span>
                                </span>
                            </div>
                            <div :data-status="task.status" :data-state="task.state" class="col-lg-3 col-6 col-sm-6 text-center">
                                <span class="fs-xl text-truncate text-truncate-lg text-dark">
                                    <span v-if="task.status == 'up' && task.state == 'on'">Работает</span>
                                    <span v-if="task.status == 'down' && task.state == 'on'">Ошибка</span>
                                    <span v-if="task.state == 'off'">Остановлено</span>
                                    <span class="d-block fs-sm fw-400 text-muted">
                                        Статус задания
                                    </span>
                                </span>
                            </div>
                            <div :data-uptime="task.statistics.uptime.month" class="col-lg-3 col-6 col-sm-6 text-center">
                                <span class="fs-xl text-truncate text-truncate-lg text-dark">
                                    {{ task.statistics.uptime.month }}%
                                    <span class="d-block fs-sm fw-400 text-muted">
                                        за месяц
                                    </span>
                                </span>
                            </div>
                            <div :data-response="task.statistics.response" class="col-lg-3 col-6 col-sm-6 text-center">
                                <span class="fs-xl text-truncate text-truncate-lg text-dark">
                                    <span v-if="task.statistics.response > 0">{{ task.statistics.response }} мс</span>
                                    <span v-if="task.statistics.response == 0">-</span>
                                    <span class="d-block fs-sm fw-400 text-muted">
                                        Время ответа
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-lg-3 text-right hidden-sm-down">
                      <router-link data-button="statistics" :to="{name: 'tasks/statistics', params: {id: task.id}}" class="btn btn-outline-primary btn-icon rounded-circle waves-effect waves-themed">
                        <i class="fal fa-info fs-md"></i>
                      </router-link>
                      <span data-button="edit" v-on:click="taskEdit(task)" class="btn btn-outline-success btn-icon rounded-circle ml-2 waves-effect waves-themed">
                          <i class="fal fa-pencil fs-md"></i>
                      </span>
                      <span data-button="state" v-on:click="taskPause(task)" class="btn btn-outline-info btn-icon rounded-circle ml-2 waves-effect waves-themed">
                          <i class="fal fa-pause fs-md" v-if="task.state == 'on'"></i>
                          <i class="fal fa-play fs-md" v-if="task.state == 'off'"></i>
                      </span>
                      <span data-button="remove" v-on:click="taskRemove(task, index)" class="btn btn-outline-secondary btn-icon rounded-circle ml-2 waves-effect waves-themed">
                          <i class="fal fa-trash fs-md"></i>
                      </span>
                    </div>
                    <div class="col-sm-4 col-4 text-right hidden-md-up text-center">
                        <div class="row">
                            <div class="col-sm-12 pb-1">
                                <router-link :to="{name: 'tasks/statistics', params: {id: task.id}}" class="btn btn-outline-primary btn-icon rounded-circle waves-effect waves-themed">
                                    <i class="fal fa-info fs-md"></i>
                                </router-link>
                                <span v-on:click="taskEdit(task)" class="btn btn-outline-success btn-icon rounded-circle ml-2 waves-effect waves-themed">
                                    <i class="fal fa-pencil fs-md"></i>
                                </span>
                            </div>
                            <div class="col-sm-12">
                                <span v-on:click="taskPause(task)" class="btn btn-outline-info btn-icon rounded-circle waves-effect waves-themed">
                                    <i class="fal fa-pause fs-md"></i>
                                </span>
                                <span v-on:click="taskRemove(task, index)" class="btn btn-outline-secondary btn-icon rounded-circle ml-2 waves-effect waves-themed">
                                    <i class="fal fa-trash fs-md"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </span>
                </li>
              </paginate>
            </div>
            <nav>
              <paginate-links
                for="tasks"
                :hide-single-page="true"
                :show-step-links="true"
                :limit="3"
                :classes="{
                  'ul': ['pagination', 'justify-content-center', 'pt-4', 'pb-0', 'mb-0'],
                  'ul > li': 'page-item',
                  'ul > li > a': 'page-link',
                }"
              ></paginate-links>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <TasksEdit v-bind:task="editTask" v-if="editStatus" v-on:close="taskEditClose"/>
    <TasksCreate type="ping" v-bind:group="group" v-if="createStatus" v-on:close="taskCreateClose"/>
  </div>
</template>

<script>
import ComponentTasksCreate from "@/components/tasks/create.vue";
import ComponentTasksEdit from "@/components/tasks/edit.vue";
import ComponentTasksGroups from "@/components/groups/list.vue";
import Vue2Filters from 'vue2-filters';

export default {
  metaInfo: {
    title: "Проверка серверов"
  },
  data() {
    return {
      // Статус загрузки
      loading: true,
      // Строка поиска
      search: '',
      searchFocus: false,
      // Задачи
      data: [],
      // Постраничная навигация
      paginate: ['tasks'],
      // Обновление данных
      interval: 0,
      // Категория
      group: null,
      // Изменение задачи
      editStatus: false,
      editTask: {},
      // Создание задачи
      createStatus: false,
    };
  },
  mixins: [Vue2Filters.mixin],
  components: {
    TasksGroups: ComponentTasksGroups,
    TasksEdit: ComponentTasksEdit,
    TasksCreate: ComponentTasksCreate
  },
  computed: {
    tasks() {
      return this.filterBy(this.data, this.search, 'name', 'value')
    }
  },
  methods: {
    // Изменение задачи
    taskEdit (task) 
    {
      this.editTask = {...task};
      this.editStatus = true;
    },
    // Завершение редактирования
    taskEditClose (tasksReload = false)
    {
      this.editStatus = false;
      this.editTask = {};

      // Обновление списка задач при сохранении
      if(tasksReload)
        this.taskListUpdate();
    },
    // Создание новой задачи
    taskCreate () 
    {
      this.createStatus = true;
    },
    // Завершение создания
    taskCreateClose (tasksReload = false)
    {
      this.createStatus = false;

      // Обновление списка задач при сохранении
      if(tasksReload)
        this.taskListUpdate();
    },
    // Обновление списка задач
    taskListUpdate (indicator = true) 
    {
      // Индикатор загрузки
      if(indicator)
        this.loading = true;

      this.$axios.post(process.env.VUE_APP_API_URL+'/v1/tasks/ping', {'group_id': this.group}).then(response =>
      {
        this.data = response.data.data;
        this.loading = false;
      });
    },
    // Изменение состояния задачи
    taskPause (task) 
    {
      task.state = (task.state == 'on') ? 'off' : 'on';

      this.$axios.post(process.env.VUE_APP_API_URL+'/v1/tasks/'+task.id+'/edit', {'state': task.state});
    },
    // Удаление задачи
    taskRemove (task, index) 
    {
      if(confirm('Вы действительно хотите удалить задание "'+task.name+'"?'))
      {
        this.$axios.get(process.env.VUE_APP_API_URL+'/v1/tasks/'+task.id+'/remove');
        this.$delete(this.data, index);
      }
    }
  },
  // Подгрузка данных
  mounted () 
  {
    this.taskListUpdate();
    this.interval = setInterval(function() { this.taskListUpdate(false); }.bind(this), 15000);
  },
  // Остановка обновления данных
  destroyed () 
  {
    clearInterval(this.interval);
  }
};
</script>